// lib
import railsPostFetch from '@aytm/lib/common/rails-post-fetch'
import { call } from 'redux-saga/effects'

// stores
import staticStore from '@aytm/app/insights/dashboard/stores/static.store'

export default function* updateOrderSaga(schema) {
  if (!staticStore.canUpdateDashboard) {
    return null
  }
  const updateOrderURL = staticStore.urls.updateOrder
  if (!updateOrderURL) {
    throw new Error('No "updateOrder" endpoint URL')
  }
  const response = yield call(railsPostFetch, updateOrderURL, {
    body: JSON.stringify({ schema: schema.toJS() })
  })
  if (!response.ok) {
    throw new Error(response.error || 'Error updating reports order')
  }
  const body = yield call([response, 'json'])
  if (!body.status) {
    throw new Error('Error updating reports order')
  }
  return body
}
